"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPropTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _reactHotkeysHook = require("react-hotkeys-hook");
var _styledComponents = require("styled-components");
var _Input = _interopRequireWildcard(require("./Input"));
var _ = require("..");
var _excluded = ["value", "onSearch", "searchOnChange", "debounce", "clearUnfocusOnEsc", "onFocus", "onBlur"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/** The Search component implements a controlled Input field with a clear button
 * By default it performs the search on enter
 * It can receive a value and it resets the search text if that value changes
 * This value is necessary for using the Search in the Header of ReactTable
 */

var searchPropTypes = _objectSpread(_objectSpread({}, _Input.inputPropTypes), {}, {
  /** Callback to be called when we perform search: on enter press and on button click  */
  onSearch: _propTypes["default"].func.isRequired,
  /** When the search should happen. If false it searches on Enter key. If true it searches when the field changes (debounced). */
  searchOnChange: _propTypes["default"].bool,
  /** The number of milliseconds to debounce the search when searchOnChange is true. Defaults to 300  */
  debounce: _propTypes["default"].number,
  /** When true: Clear and blur on Esc  */
  clearUnfocusOnEsc: _propTypes["default"].bool
});
exports.searchPropTypes = searchPropTypes;
var Search = function Search(_ref) {
  var value = _ref.value,
    onSearch = _ref.onSearch,
    _ref$searchOnChange = _ref.searchOnChange,
    searchOnChange = _ref$searchOnChange === void 0 ? false : _ref$searchOnChange,
    _ref$debounce = _ref.debounce,
    debounce = _ref$debounce === void 0 ? 300 : _ref$debounce,
    _ref$clearUnfocusOnEs = _ref.clearUnfocusOnEsc,
    clearUnfocusOnEsc = _ref$clearUnfocusOnEs === void 0 ? false : _ref$clearUnfocusOnEs,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(value || ""),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var inputRef = (0, _react.useRef)(null);
  var theme = (0, _styledComponents.useTheme)();
  (0, _react.useEffect)(function () {
    if (searchOnChange) {
      return;
    }
    setText(value || "");
  }, [searchOnChange, value]);
  (0, _reactUse.useDebounce)(function () {
    if (searchOnChange) {
      onSearch === null || onSearch === void 0 ? void 0 : onSearch(text);
    }
  }, debounce, [text]);
  var clearHandler = (0, _react.useCallback)(function () {
    setText("");
    onSearch("");
  }, [onSearch]);
  var changeHandler = (0, _react.useCallback)(function (e) {
    setText(e.target.value);
  }, []);
  var enterActionHandler = (0, _react.useCallback)(function () {
    if (!searchOnChange) {
      onSearch(text);
    }
  }, [onSearch, text, searchOnChange]);
  var escHandler = (0, _react.useCallback)(function () {
    clearHandler();
    inputRef.current.blur();
  }, [clearHandler]);
  (0, _reactHotkeysHook.useHotkeys)("esc", escHandler, {
    enableOnTags: ["INPUT"],
    enabled: isFocused && clearUnfocusOnEsc
  });
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    type: "search",
    value: text,
    onChange: changeHandler,
    enterKeyPress: enterActionHandler,
    onClear: clearHandler,
    withClearButton: true,
    unfocusAfterEnter: !clearUnfocusOnEsc // can be overwritten
    ,
    onFocus: function onFocus(e) {
      // the isFocused state is only used for the esc key functionality
      if (clearUnfocusOnEsc) {
        setIsFocused(true);
      }
      _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(e);
    },
    onBlur: function onBlur(e) {
      // the isFocused state is only used for the esc key functionality
      if (clearUnfocusOnEsc) {
        setIsFocused(false);
      }
      _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(e);
    },
    renderLeft: function renderLeft() {
      return /*#__PURE__*/_react["default"].createElement(_.Icon, {
        name: "Search",
        size: "xs",
        p: "s",
        color: "textSecondary"
      });
    },
    variant: theme.fields.searchVariant /* can be overridden */,
    forwardedRef: inputRef
  }, rest));
};
Search.propTypes = searchPropTypes;
Search.defaultProps = {
  placeholder: "Search"
};
var _default = Search;
exports["default"] = _default;